export default __webpack_public_path__ + "locales/pt/SalesDepartmentRequestDialog.json?hash=7806477ca5eb085ee4a094c774b375f5";